module.exports = __webpack_public_path__ + "static/media/living.b4d50713.gif";